import Config from '@config';
import { initializeAppSettingsApi } from '@gasbi/shared/common/features';

import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const { appSettingsApi, useGetAppSettingsQuery, useAppSettings } =
  initializeAppSettingsApi(Config.VITE_API_CLIENT_URL, axiosBaseQuery);
